import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import _ from 'lodash';
import Constants from '../../config/constants';
import Form from '../form/Form';
import FieldGroup from '../field_group/FieldGroup';
import { getErrorValue } from '../../utils/utility';

import { findAccountByUsername } from '../../redux/profile/profile_actions';

export class ProjectMemberInvitationForm extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = null;

    this.state = { isDirty: false };
  }

  getSubmissionData() {
    return this.formRef.getFormData();
  }

  reset() {
    this.formRef.clearInputData();
    this.setState({ isDirty: false });
  }

  componentDidMount() {
    if (this.props.submission) {
      this.props.listAttachment(this.props.submission);
    }
  }

  renderStatus() {
    const { isFinding, isValid, t } = this.props;
    let msg = ' ';
    if (!this.state.isDirty) {
      msg = ' ';
    } else if (!isFinding && !isValid) {
      msg = 'not found';
    } else if (isFinding) {
      msg = 'searching...';
    }

    return <span>{t(msg)}</span>;
  }

  render() {
    const { disabled, fieldErrors, t, findAccount, isValid, onDirty, ...otherAttr } = this.props;
    const customAttr = { disabled };
    return (
      <React.Fragment>
        <Form
          {...otherAttr}
          showThumbnail={false}
          ref={ref => (this.formRef = ref)}
          errorMessage={getErrorValue(fieldErrors, 'detail')}
          onDirty={dirty => {
            this.setState({ isDirty: this.state.isDirty || dirty });
            if (onDirty) {
              onDirty(dirty);
            }
          }}
        >
          <FieldGroup
            id="project-member-invite"
            field="invitee"
            label={t('username')}
            value=""
            onValueChange={value => value && findAccount(value)}
            {...customAttr}
          />
        </Form>
        {this.renderStatus()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  isFinding: state.profile.isFinding,
  isValid: !!state.profile.account,
});

const mapDispatchToProps = dispatch => ({
  findAccount: _.debounce(username => dispatch(findAccountByUsername(username)), Constants.DEBOUNCE_TIME),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(ProjectMemberInvitationForm),
);



// WEBPACK FOOTER //
// ./src/components/member/ProjectMemberInvitationForm.js